import { useInfiniteQuery } from 'react-query'

import { LatestUpdateParam } from '@models/latestUpdate/LatestUpdateParam'
import { useAuthentication } from '@hooks/useAuthentication'
import { useLatestUpdateAction } from './useLatestUpdateAction'

export function useGetLatestUpdatedBooks(params: LatestUpdateParam) {
  const latestUpdateClient = useLatestUpdateAction()
  const { canFetchApi } = useAuthentication()

  const { fetchNextPage, data, isLoading, isFetchingNextPage } =
    useInfiniteQuery(
      ['latest_update', params],
      async ({ pageParam = 1 }) => {
        return latestUpdateClient.getLatestUpdatedBooks({
          ...params,
          page: pageParam,
        })
      },
      {
        enabled: canFetchApi,
        getNextPageParam: lastPage => {
          if (
            lastPage &&
            lastPage.page * params.limitPerPage < lastPage.total &&
            lastPage.page * params.limitPerPage < 200
          )
            return lastPage.page + 1

          return undefined
        },
      }
    )

  function handleFetchNextPage() {
    if (!isFetchingNextPage) fetchNextPage()
  }

  return {
    data,
    isLoading,
    handleFetchNextPage,
  }
}
